import React, { useMemo } from 'react';
import c from 'classnames';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { SCREEN_TABLET } from '../../../config/constants';
import SkeletonWrapper from '../../SkeletonWrapper';

import './style.scss';

export interface BlockStreakProps {
  variant?: 'small';
  className?: string;
}

const BlockStreak: React.FC<BlockStreakProps> = (props) => {
  const { variant, className } = props;

  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const isInitialLoaded = useSelector<ImmutableRootState<boolean>, boolean>((state) => state.getIn(['registrations', 'isInitialLoaded'], false));
  const completedRegistrations = useSelector<ImmutableRootState<number>, number>((state) => state.getIn(['registrations', 'streaks', 'completed'], 0));
  const success = useSelector<ImmutableRootState<number>, number>((state) => state.getIn(['registrations', 'streaks', 'success'], 0)) || 0;
  const cheated = useSelector<ImmutableRootState<number>, number>((state) => state.getIn(['registrations', 'streaks', 'failed'], 0)) || 0;
  const dateStarted = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['registrations', 'registrationsStartDate']));

  const daysSinceStart = moment().diff(moment(dateStarted).startOf('day'), 'day') + 1;

  const classNames = c('BlockStreak', className, {
    [`BlockStreak--variant--${variant}`]: variant,
  });

  const hasNoText = useMemo(() => (
    variant === 'small' && width < SCREEN_TABLET
  ), [variant, width]);

  return (
    <div className={classNames}>
      <SkeletonWrapper active={!isInitialLoaded} className="BlockStreak__skeleton">
        <div className="BlockStreak__content">
          <div className="BlockStreak__content__item">
            <i className="icon icon-streak" />
            <span className="asH5">
              {t(`common:blocks.streak.${hasNoText ? 'no_text' : 'default'}.registration_days`, { count: completedRegistrations, total: daysSinceStart })}
            </span>
          </div>

          <div className="BlockStreak__content__item">
            <i className="icon icon-happy" />
            <span className="asH5">
              {t(`common:blocks.streak.${hasNoText ? 'no_text' : 'default'}.success`, { count: success })}
            </span>
          </div>

          <div className="BlockStreak__content__item">
            <i className="icon icon-sad" />
            <span className="asH5">
              {t(`common:blocks.streak.${hasNoText ? 'no_text' : 'default'}.fails`, { count: cheated })}
            </span>
          </div>
        </div>
      </SkeletonWrapper>
    </div>
  );
};

export default BlockStreak;
